import { render, staticRenderFns } from "./CollezionamentoCard.vue?vue&type=template&id=072db878"
import script from "./CollezionamentoCard.vue?vue&type=script&lang=js"
export * from "./CollezionamentoCard.vue?vue&type=script&lang=js"
import style0 from "./CollezionamentoCard.vue?vue&type=style&index=0&id=072db878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports